import { render, staticRenderFns } from "./TrafficDecision.vue?vue&type=template&id=5bf8709e"
import script from "./TrafficDecision.vue?vue&type=script&lang=js"
export * from "./TrafficDecision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports